import { Component, computed, inject } from '@angular/core';
import { DotCMSLayoutBodyComponent } from '@dotcms/angular';
import { DotCMSPageAsset } from '@dotcms/types';

import { LoadingComponent } from 'ish-shared/components/common/loading/loading.component';

import { DYNAMIC_COMPONENTS } from '../../configurations/dynamic-components';
import { DotCmsColumnClassCleanupDirective } from '../../directives/dot-cms-column-class-cleanup.directives';
import { DotCmsUveFacade } from '../../facades/dot-cms-uve.facade';
import { ExtraContent } from '../../models/dot-cms-uve-contentlet.model';
import { DotCmsUveEditablePageService } from '../../services/dot-cms-uve-editable-page/dot-cms-uve-editable-page.service';

export type DotCMSPage = {
  pageAsset: DotCMSPageAsset;
  content: ExtraContent;
};

@Component({
  selector: 'custom-dot-cms-uve-page',
  standalone: true,
  imports: [DotCMSLayoutBodyComponent, LoadingComponent, DotCmsColumnClassCleanupDirective],
  providers: [DotCmsUveEditablePageService],
  templateUrl: './dot-cms-uve-page.component.html',
})
export class DotCmsUvePageComponent {
  readonly components = DYNAMIC_COMPONENTS;
  private readonly dotCmsUveFacade = inject(DotCmsUveFacade);
  readonly $pageState = this.dotCmsUveFacade.pageState;
  readonly pageLoading = this.dotCmsUveFacade.pageLoading;
  readonly $page = computed(() => {
    const pageState = this.$pageState();
    const currentRoute = this.dotCmsUveFacade.$pageUrl();
    if (
      pageState?.pageResponse?.pageAsset &&
      currentRoute &&
      pageState.pageResponse.pageAsset.page.url === `${currentRoute}`
    ) {
      queueMicrotask(() => this.dotCmsUveFacade.setTransparentHeader());
      return pageState;
    }
    return null;
  });
}
